import * as React from "react";
import * as models from "app/models/requireme";
import * as kea from "kea-react";
import * as resources from "app/resources/index";
import * as selectores from "app/features/selectores/index";
import * as history from "app/main/history";
import { Route, Redirect, withRouter, match } from "react-router";
import { createSelectorRx } from "keautils";
import { validation, formfields } from "kea-react"
import { fa } from "typed-font-awesome";
import { componentToRx } from "app/logic/rx";
import { observeResource } from "kea-resource";

import { SelectorFiltradoFactory } from "../logic";

function viajeSearchString(x: models.ViajeRutaDto) {
    return `${x.Folio} ${x.NombreSucursalOrigen} ${x.NombreSucursalDestinio} ${models.StatusViajeRuta[x.Status]} ${x.NombreCamion} ${x.NombreChofer}`;
}

class ViajeItem extends React.PureComponent<{ value: models.ViajeRutaDto }> {
    render() {
        const x = this.props.value;
        return (
            <div>
                <span >
                    <b>{x.Folio}</b>
                    {" "}
                    {x.NombreSucursalOrigen + ", " + x.NombreSucursalDestinio}
                    <span className="label label-info">
                        {models.StatusViajeRuta[x.Status]}
                    </span>
                </span>

                <br />
                <span style={{ fontStyle: "italic" }} >{x.NombreCamion}</span>
                <br />
                <span style={{ fontStyle: "italic" }} >{x.NombreChofer}</span>
            </div>
        );
    }
}

/**Selector filtrado de los viajes de ruta */
export const ViajeRuta =
    SelectorFiltradoFactory<models.ViajeRutaDto, models.FiltroViajeList>(
        filtro => observeResource(resources.ViajeRuta.ConsultarViajes, filtro || {}),
        x => x.IdRegistro,
        x => ({
            label: viajeSearchString(x),
            view: <ViajeItem value={x} />
        })
    );



// WEBPACK FOOTER //
// ./app/features/selectores/items/viaje.tsx